import { FilteredClientAccount } from '@shared/models';
import {
  ISelectedClientAccountsState,
  TransactionTypesEnum,
} from '@store/reducers/selected-client-accounts/selected-client-accounts.reducer';

export const getMinorTransferFromNextPage = (individualAccounts: FilteredClientAccount): string =>
  individualAccounts.accounts.length > 0
    ? 'secure/minor-transfer/transfer-to'
    : 'secure/minor-transfer/personal-info';
export const getMinorTransferToNextPage = (
  selectedAccounts: ISelectedClientAccountsState,
): string =>
  selectedAccounts.transactionType === TransactionTypesEnum.EXISTING
    ? 'secure/minor-transfer/review'
    : 'secure/minor-transfer/personal-info';
export const getMinorPersonalInfoNextPage = (): string => 'secure/minor-transfer/contact-info';
export const getMinorContactInfoNextPage = (settlementFundToggle: boolean): string =>
  settlementFundToggle
    ? 'secure/minor-transfer/settlement-fund'
    : 'secure/minor-transfer/employment';
export const getMinorSettlementFundNextPage = (): string => 'secure/minor-transfer/employment';
export const getMinorEmploymentNextPage = (): string => 'secure/minor-transfer/income-net-worth';
export const getMinorIncomeNetWorthNextPage = (): string =>
  'secure/minor-transfer/investment-objectives';
export const getMinorInvestObjNextPage = (): string => 'secure/minor-transfer/review';
export const getMinorReviewNextPage = (selectedAccounts: ISelectedClientAccountsState): string =>
  selectedAccounts.transactionType === 'EXISTING'
    ? 'secure/minor-transfer/terms/existing'
    : 'secure/minor-transfer/terms/new';
export const getMinorTermsNextPage = (): string => {
  return 'secure/minor-transfer/confirm';
};
export const getOpenChoiceEnrollPage = (): string => 'secure/open-choice/enroll';
